import { useMutation, useQueryClient } from 'react-query'
import { useToast } from '@chakra-ui/react'

import { fetchAPI } from '@/lib/api'
import { getErrorMsg, t } from '@/lib/helpers'

import { POSTS } from '../constants'

const updatePost = async (id: number) => {
  await fetchAPI({
    method: 'put',
    path: `/posts/${id}/hide`,
  })
}

export const useUpdatePost = () => {
  const toast = useToast()
  const queryClient = useQueryClient()

  return useMutation(updatePost, {
    onSuccess: async () => {
      await queryClient.refetchQueries([POSTS])

      toast({
        description: t('views.admin.posts.services.update_success'),
        status: 'success',
        position: 'top-right',
        isClosable: true,
      })
    },
    onError(error) {
      toast({
        description: getErrorMsg(error),
        status: 'error',
        position: 'top-right',
        variant: 'left-accent',
        isClosable: true,
      })
    },
  })
}
